<div *transloco="let t">
	<vex-page-layout mode="card">
		<vex-page-layout-header class="pb-16 flex flex-col justify-center items-start">
			<div class="mt-4">
				<div class="flex flex-row">
					<h1 class="title mt-0 mb-1">
						{{ t('tenantunits.tenantunit') }}
					</h1>
					<mat-icon
						#tooltip="matTooltip"
						[svgIcon]="icons.get('infoOutline')"
						[matTooltip]="t('tenantunitDetails.infoMessage')"
						[matTooltipHideDelay]="1000"
						style="margin-left: 10px"></mat-icon>
				</div>

				<vex-breadcrumbs [crumbs]="breadCrumbService.crumbs"></vex-breadcrumbs>
			</div>
		</vex-page-layout-header>
		<vex-page-layout-content class="-mt-6">
			<ara-tenant-detail-cards></ara-tenant-detail-cards>

			<div>
				<button
					(click)="openCustomSettings()"
					[disabled]="!showManualDeliveryOptionSetting()"
					class="mt-5 tenant-unit-detail-settings-button"
					color="primary"
					[matTooltip]="t('tenantunitDetails.uviSettings')"
					mat-raised-button>
					<mat-icon [svgIcon]="icons.get('settings')"></mat-icon>
					@if (!layoutService.isMobile()) {
						<span class="ml-1">{{ t('tenantunitDetails.uviSettings') }}</span>
					}
				</button>
			</div>
			<div class="card overflow-auto mt-4 pb-2">
				<mat-tab-group class="ml-6 tenant-unit-tabs" [mat-stretch-tabs]="false" preserveContent>
					<mat-tab label="{{ t('tenantunitDetails.tenantManagement') }}">
						<ara-roles-view class="mt-6"></ara-roles-view>
					</mat-tab>
					@if (billingUnit()?.portalActive) {
						<mat-tab label="{{ t('tenantunitDetails.tenantShares') }}">
							@defer {
								<ara-tenant-share-value [currentTenantUnit]="selectedTenantUnit()"></ara-tenant-share-value>
							} @loading {
								<mat-spinner color="primary"></mat-spinner>
							} @placeholder {
								<p>Placeholder content</p>
							}
						</mat-tab>
						@if (billingUnit().exportId && selectedTenantUnitReference()?.exportId) {
							<mat-tab label="{{ t('billing.tenantData') }}">
								@defer {
									<ara-tenant-unit-reference
										[billingId]="billingUnit().exportId"
										[selectedInstance]="selectedTenantUnitReference()"></ara-tenant-unit-reference>
								} @loading {
									<mat-spinner color="primary"></mat-spinner>
								} @placeholder {
									<p>Placeholder content</p>
								}
							</mat-tab>
						}
					}
				</mat-tab-group>
			</div>
		</vex-page-layout-content>
	</vex-page-layout>
</div>
